import { Image } from 'react-bootstrap'
import { icons } from './icons'
import { IconName } from './types'
import { CSSProperties } from 'react'

interface IconProps {
  name: IconName
  className?: string
  style?: CSSProperties
  [key: string]: any
}

export type { IconName }
export default function Icon({ name, className, style, ...othersProps }: IconProps) {
  const src = icons[name]

  if (!src) {
    console.error(`[Icon] 找不到图标: ${name}`)
    return null
  }

  return <Image src={src} className={className} alt={`icon-${name}`} style={style} {...othersProps} />
}
